@if (visible()) {
  <div class="banner">
    <button mat-icon-button class="close-btn" (click)="dismiss()" aria-label="Banner schließen">
      <ui-icon faName="xmark" faStyle="light"></ui-icon>
    </button>

    <a class="store-link" [href]="store().href">
      <img class="logo" src="./assets/img/lekkerland24-logo-round.svg" alt="" aria-hidden="true" />

      <div class="app-info">
        <span class="app-name">Lekkerland24</span>
      </div>

      <img class="store-badge" [src]="store().badgeSrc" [alt]="store().badgeAlt" />
    </a>
  </div>
}
